import {combineReducers} from "redux";
import listReducer, * as listSelectors from './listReducer';
import {translate} from '@elements/translations';

export default combineReducers({
    list: listReducer
});

export const getListFetchingState = (state) => listSelectors.getFetchingState(state.list);
export const getListItems = (state) => listSelectors.getItems(state.list);
export const getListAvailableCategories = (state) => listSelectors.getAvailableCategories(state.list);
export const getListStartDate = (state) => listSelectors.getStartDate(state.list);
export const getListEndDate = (state) => listSelectors.getEndDate(state.list);
export const getNotesByIds = (state, ids) => listSelectors.getNotesByIds(state.list, ids);
export const getInvoicesByIds = (state, ids) => listSelectors.getInvoicesByIds(state.list, ids);
export const getInvoicesFetchingState = (state) => listSelectors.getInvoicesFetchingState(state.list);
export const getOrdersById = (state, id) => listSelectors.getOrdersById(state.list, id);
